import { render, staticRenderFns } from "./Survey-list.vue?vue&type=template&id=77f820e5&"
import script from "./Survey-list.vue?vue&type=script&lang=js&"
export * from "./Survey-list.vue?vue&type=script&lang=js&"
import style0 from "./Survey-list.vue?vue&type=style&index=0&id=77f820e5&prod&lang=scss&spaced=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports